import React, { Component } from "react";

class App extends Component {
  state = {
    showModal: false
  };

  render() {
    return (
      <div>
        <nav
          className="navbar is-white"
          role="navigation"
          aria-label="main navigation"
        >
          <div className="container">
            <div className="navbar-brand">
              <a className="navbar-item" href="https://trykove.com">
                <img className="brand-logo" src="/logo-high-res.svg" alt="" />
              </a>
              <a
                role="button"
                className="navbar-burger"
                data-target="navMenu"
                aria-label="menu"
                aria-expanded="false"
                onClick={() => {
                  let toggle = document.querySelector(".navbar-burger");
                  let menu = document.querySelector(".navbar-menu");
                  toggle.classList.toggle("is-active");
                  menu.classList.toggle("is-active");
                }}
              >
                <span aria-hidden="true" />
                <span aria-hidden="true" />
                <span aria-hidden="true" />
              </a>
            </div>

            <div className="navbar-menu" id="navMenu">
              <div className="navbar-end">
                <a className="navbar-item" href="mailto:info@trykove.com">
                  Contact
                </a>
              </div>
            </div>
          </div>
        </nav>

        <section className="section main-content">
          <div className="container">
            <div className="columns is-desktop">
              <div className="column has-text-centered-mobile">
                <p className="brand-tag">Insurance Reimagined</p>
                <p className="brand-subtag">
                  We believe insurance can be better. <br />
                  Tell us what you think!
                </p>
                <a
                  className="button is-primary is-large survey"
                  href="https://docs.google.com/forms/d/e/1FAIpQLSfoyXZXQGT_tiycT-wljlX9VOahFDwzHTwpb_mI8k7I1xIoAA/viewform"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Take the survey
                </a>
              </div>
              <div className="column">
                <img className="illustration" src="/il2.svg" alt="" />
              </div>
            </div>
          </div>
        </section>

        <footer className="footer">
          <div className="container">
            <div className="content has-text-left has-text-centered-mobile">
              <div className="copyright is-pulled-right">
                &copy; Copyright 2018, Kove Inc. All Rights Reserved.
                <a
                  className="disclaimer"
                  onClick={() => {
                    this.setState({ showModal: true });
                  }}
                >
                  Disclaimer
                </a>
              </div>
              <div className="social">
                <ul className="list-inline">
                  <li>
                    <a
                      href="https://twitter.com/KoveInc"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span className="icon">
                        <i className="fab fa-twitter" />
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.facebook.com/KoveInsurance/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span className="icon">
                        <i className="fab fa-facebook" />
                      </span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </footer>
        <div className={this.state.showModal ? "modal is-active" : "modal"}>
          <div className="modal-background" />
          <div className="modal-card">
            <header className="modal-card-head">
              <p className="modal-card-title">Disclaimer</p>
              <button
                className="delete"
                aria-label="close"
                onClick={() => {
                  this.setState({ showModal: false });
                }}
              />
            </header>
            <section className="modal-card-body">
              This is not an offer for insurance or coverage. All opinions
              provided are done so for market research purposes regarding the
              insurance industry generally, and nothing herein is intended as
              advice for any particular person or situation. Any descriptions of
              insurance coverage referenced herein are purely hypothetical and
              are not being offered.
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js